export default __webpack_public_path__ + "static/media/secondary_message_icon.7c69d9fd.svg";